<template>
  <div>
    <div v-if="!loading">
      <CompetitionEmptyState v-if="!selectCompetitors.length" />

      <SlideFadeTransition v-else>
        <router-view />
      </SlideFadeTransition>
    </div>

    <!-- loader -->
    <div v-else>
      <FullLoader />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import SlideFadeTransition from '../../Transitions/SlideFadeTransition'
import FullLoader from '@/components/MainContent/FullLoader'
import CompetitionEmptyState from './CompetitionEmptyState.vue'

const GroupModule = createNamespacedHelpers('group')
const DataCoreModule = createNamespacedHelpers('dataCore')
const LocationModule = createNamespacedHelpers('location')
const CompetitionModule = createNamespacedHelpers('competition')
const InsightsModule = createNamespacedHelpers('insightsv2')

export default {
  name: 'CompetitionViews',
  components: {
    SlideFadeTransition,
    FullLoader,
    CompetitionEmptyState
  },
  data: () => ({
    loading: true
  }),
  async mounted() {
    await Promise.all([
      this.getUserLocationsByActiveCompany(),
      this.fetchGroups({
        memberType: 'location',
        companyIds: this.selectActiveCompanyIds
      }),
      this.fetchCompetitors(),
      this.fetchCategories()
    ])
    this.loading = false
  },
  computed: {
    ...DataCoreModule.mapGetters(['selectActiveCompanyIds']),
    ...CompetitionModule.mapGetters(['selectCompetitors'])
  },
  methods: {
    ...GroupModule.mapActions(['fetchGroups']),
    ...LocationModule.mapActions(['getUserLocationsByActiveCompany']),
    ...CompetitionModule.mapActions(['fetchCompetitors']),
    ...InsightsModule.mapActions(['fetchCategories'])
  }
}
</script>
